import { createSelector } from 'reselect';
import get from 'lodash/get';
import { SCOPE } from './types';

const selector = state => state[SCOPE];

export default selector;

export const birdChartDataSelector = createSelector(
  selector,
  birdChartStore => get(birdChartStore, 'response') || {},
);

export const birdChartSliceDataSelector = createSelector(
  selector,
  birdChartStore => get(birdChartStore, 'sliceResponse') || null,
);

export const birdChartSliceSelector = createSelector(
  selector,
  (birdChartStore) => {
    const {
      sliceFrom,
      sliceTo,
      lastSliceFrom: brushStart,
      lastSliceTo: brushEnd,
      lastSliderFrom: zoomStart,
      lastSliderTo: zoomEnd,
    } = birdChartStore;

    const birdChart = {};
    if (sliceFrom || sliceTo) {
      birdChart.sliceFrom = sliceFrom;
      birdChart.sliceTo = sliceTo;
    }
    if (zoomStart || zoomEnd) {
      birdChart.zoomStart = zoomStart;
      birdChart.zoomEnd = zoomEnd;
    }
    if (brushStart || brushEnd) {
      birdChart.brushStart = brushStart;
      birdChart.brushEnd = brushEnd;
    }
    return birdChart;
  },
);
